// extracted by mini-css-extract-plugin
export default {"form":"VacanciesForm_form__HP97T","button":"VacanciesForm_button__cE8k6","formGroup":"VacanciesForm_formGroup__dxKcR","editor":"VacanciesForm_editor__ijeJP"};